import { useMutation } from '@tanstack/react-query';
import { uploadMedia } from 'utils/mediaResourceUtils';

export const useUploadMedia = () =>
  useMutation({
    mutationFn: ({ media, resourceType = 'image', forceUpload = false }) =>
      uploadMedia(media, resourceType, forceUpload),
  });
